export const getDegreeForRegisterNoGeneration = (state = [], action) => {
  switch (action.type) {
    case "REGISTER_DEG":
      return action.payload;
    default:
      return state;
  }
};
export const getCollcodeForDegreeToRegisterNoGen = (state = [], action) => {
  switch (action.type) {
    case "REGISTER_COLLCODE":
      return action.payload;
    default:
      return state;
  }
};

export const getStudentForDegreeToRegisterNoGen = (state = [], action) => {
  switch (action.type) {
    case "REGISTER_STUD_COUNT":
      return action.payload;
    default:
      return state;
  }
};

export const getPrefix = (state = [], action) => {
  switch (action.type) {
    case "REGISTER_STUD_PREFIX":
      return action.payload;
    default:
      return state;
  }
};
export const saveRegisterNoGeberation = (state = [], action) => {
  switch (action.type) {
    case "GENERATED":
      return action.payload;
    default:
      return state;
  }
};
